/**
 * React context for the key of the silo a page renders in.
 *
 * The key is `null` outside any silo.
 */

import React from 'react';

export const SiloContext = React.createContext<string | null>(null);
